import React, { useState } from "react";

const SubscribeForm = ({ onSubscribe }) => {
  const [email, setEmail] = useState("");
  const [hiddenHoneypot, setHiddenHoneypot] = useState(""); // bot trap
  const [error, setError] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | success

  const validateEmail = (value) => {
    // simple, safe email check (digit-by-digit safe per instructions)
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    // honeypot filled => likely bot: silently ignore
    if (hiddenHoneypot.trim() !== "") {
      return;
    }

    if (!email.trim()) {
      setError("Please enter your email.");
      return;
    }

    if (!validateEmail(email.trim())) {
      setError("Please enter a valid email address.");
      return;
    }

    setStatus("sending");

    // Simulate sending (replace this block with your API call)
    setTimeout(() => {
      setStatus("success");
      setEmail("");
      if (typeof onSubscribe === "function") onSubscribe();
    }, 700);
  };

  if (status === "success") {
    return (
      <div className="subscribe-success" role="status" aria-live="polite">
        🎉 Thanks — you’re subscribed!
      </div>
    );
  }

  return (
    <form className="subscribe-form" onSubmit={handleSubmit} noValidate>
      {/* Honeypot (hidden field) */}
      <label htmlFor="company" className="sr-only">Company</label>
      <input
        type="text"
        id="company"
        name="company"
        value={hiddenHoneypot}
        onChange={(e) => setHiddenHoneypot(e.target.value)}
        className="honeypot"
        tabIndex="-1"
        autoComplete="off"
      />

      <label htmlFor="subscribe-email" className="sr-only">
        Email address
      </label>
      <div className="subscribe-row">
        <input
          id="subscribe-email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="subscribe-input"
          aria-label="Email address"
          required
        />
        <button
          type="submit"
          className="subscribe-button"
          aria-disabled={status === "sending"}
        >
          {status === "sending" ? "Sending..." : "Subscribe"}
        </button>
      </div>

      {error && (
        <div className="subscribe-error" role="alert" aria-live="assertive">
          {error}
        </div>
      )}
    </form>
  );
};

export default SubscribeForm;
